import { render, staticRenderFns } from "./newcomer-campaign.vue?vue&type=template&id=a6f931c8&scoped=true"
import script from "./newcomer-campaign.vue?vue&type=script&lang=js"
export * from "./newcomer-campaign.vue?vue&type=script&lang=js"
import style0 from "./newcomer-campaign.vue?vue&type=style&index=0&id=a6f931c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f931c8",
  null
  
)

export default component.exports